import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import Homescreen from './Home';
import Header from '../components/header';
import Popup from '../components/popup';
import FreightTypePopup from '../components/freightTypePopup';
import ForgotPopup from '../components/forgotPopup';
import SetPasswordPopup from '../components/setPasswordPopup';
import UserPopup from '../components/userPopup';
import ManageMarketPopup from '../components/manageMarketPopup';
import ManageProductPopup from '../components/manageProductPopup';
import SaveViewPopup from '../components/saveViewPopup';
import IndexPopup from '../components/indexPopup';
import SingleOrder from './orders/singleOrder';
import ExpiredOrders from './orders/ExpiredTrades';
import CompletedTrades from './orders/CompletedTrades';
import BidPopup from '../components/bidPopup';
import CustomNotificationPopup from '../components/CustomNotificationPopup';
import Login from '../components/login';
import Progress from '../components/progress';
import ContextMenu from '../components/contextMenu';
import Footer from '../components/footer';
import ImpersonatingBanner from '../components/ImpersonatingBanner';
import ManageTabPopup from '../components/manageTapPopup';

// Actions
import * as appActions from '../actions/appActions';
import * as userActions from '../actions/userActions';
import * as ordersActions from '../actions/ordersActions';
import * as indicesActions from '../actions/indicesActions';
import * as freightTypesActions from '../actions/freightTypesActions';
import * as marketsActions from '../actions/marketsActions';
import * as customViewsActions from '../actions/customViewsActions';
import * as companiesActions from '../actions/companiesActions';
import * as socketActions from '../actions/socketActions';
import * as notificationsActions from '../actions/notificationsActions';

// App config
import appConfig from '../config/app-config';

// Utils
import { getCookie } from '../services/cookie';
import { getOrderLineElement } from '../services/utils';
import { createAxiosMiddlewareMain, createAxiosMiddlewareRetry } from '../services/api';

class App extends React.Component {
    constructor(props) {
        super(props);

        this.handleESC = this.handleESC.bind(this);
        this.handleContextEvent = this.handleContextEvent.bind(this);
        this.handleButtonPress = this.handleButtonPress.bind(this);
        this.handleButtonRelease = this.handleButtonRelease.bind(this);

        createAxiosMiddlewareMain(props);
        createAxiosMiddlewareRetry(props);
    }

    componentDidMount() {
        // All for signup data
        this.props.actions.getMarketsList();
        this.props.actions.getCountriesList();

        const authtoken = getCookie(appConfig.authtoken);
        if (!(authtoken == null || authtoken.length == 0)) {
            this.props.actions.autoLogin(() => this.checkPathForOrder());
        }

        document.addEventListener('keydown', e => {
            if (e.ctrlKey && e.keyCode == 66) {
                // ctrl + b for create
                this.props.actions.showOrderPopup('create');
            }
            if (e.keyCode === 27) {
                // ESC key
                this.handleESC();
            }
        });

        document.addEventListener('contextmenu', this.handleContextEvent);
        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            document.addEventListener('touchstart', this.handleButtonPress);
            document.addEventListener('touchend', this.handleButtonRelease);
        }

        this.props.actions.socketConnect();
    }

    checkPathForOrder() {
        const { location, actions } = this.props;

        if (location.pathname == '/onlinemarkets' && location.query && location.query.order) {
            actions.getOrder(location.query.order, 'bid', (_, data) => {
                const user = this.props.state.user;
                const isSuperUser = user.isAdmin || user.isSuperUser;
                const hideCme = !user.userInfo.cme_cleared && data.contract_type == 'CME';

                if (isSuperUser) {
                    data.status === 'CLOSED'
                        ? actions.showOrderPopup('edit-finalised', data)
                        : actions.placeOrder(data);
                } else {
                    hideCme || data.status === 'CLOSED'
                        ? actions.showOrderPopup('view', data)
                        : data.type !== 'Regular' || data.status === 'EXPIRED'
                        ? actions.callDH(data)
                        : actions.placeOrder(data);
                }
            });
        }
    }

    handleButtonPress(e) {
        const { visible } = this.props.state.app.context;

        if (this.props.state.user.isLoggedIn) {
            this.buttonPressTimer = setTimeout(() => this.handleContextEvent(e), 500);
        }
    }

    handleButtonRelease(e) {
        const { visible } = this.props.state.app.context;

        if (this.props.state.user.isLoggedIn) {
            clearTimeout(this.buttonPressTimer);
        }
    }

    handleContextEvent(e) {
        const { visible } = this.props.state.app.context;

        if (this.props.state.user.isLoggedIn) {
            let params = false;
            let orderLine = getOrderLineElement(e);
            if (orderLine) {
                params = {
                    trading_period: orderLine.getAttribute('trading_period'),
                    product_id: orderLine.getAttribute('productid'),
                    extended: true,

                    contract_type: orderLine.getAttribute('contract_type'),
                    order_id_buy: orderLine.getAttribute('orderid_buy'),
                    price_buy: orderLine.getAttribute('price_buy'),
                    quantity_buy: orderLine.getAttribute('quantity_buy'),
                    creator_company_id_buy: orderLine.getAttribute('creator_company_id_buy'),
                    status_buy: orderLine.getAttribute('status_buy'),
                    isExpired_buy: orderLine.getAttribute('isexpired_buy'),

                    order_id_sell: orderLine.getAttribute('orderid_sell'),
                    price_sell: orderLine.getAttribute('price_sell'),
                    quantity_sell: orderLine.getAttribute('quantity_sell'),
                    creator_company_id_sell: orderLine.getAttribute('creator_company_id_sell'),
                    status_sell: orderLine.getAttribute('status_sell'),
                    isExpired_sell: orderLine.getAttribute('isexpired_sell'),
                };
            }
            if (!visible) {
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;
                this.props.actions.showContext(clientX, clientY, params);
            } else {
                this.props.actions.hideContext();
            }
            e.preventDefault();
        }
    }

    handleESC() {
        const { actions } = this.props;
        const {
            isBidPopupVisible,
            isOnlineMarketLogVisible,
            isManageMarketPopupVisible,
            isManageProductPopupVisible,
            marketlogFilter,
        } = this.props.state.markets;

        const { isGridViewPopupVisible } = this.props.state.customViews;

        const { isOrderPopupVisible } = this.props.state.orders;
        const { isExpiredOrdersPopupVisible } = this.props.state.orders; // TODO: IMPLEMENT THESE
        const { isCompletedTradesPopupVisible } = this.props.state.orders; // TODO: IMPLEMENT THESE
        const { inicesPopupVisible } = this.props.state.indices;
        const { isCustomNotificationPopupVisible } = this.props.state.notifications;
        const {
            isPopupVisible,
            isUserPopupVisible,
            isForgotPopupVisible,
            isSaveViewPopupVisible,
            isLoginVisible,
            context,
        } = this.props.state.app;
        const { freightTypePopupVisible } = this.props.state.freightTypes;

        if (
            isOnlineMarketLogVisible &&
            !isOrderPopupVisible &&
            !isExpiredOrdersPopupVisible &&
            !isCompletedTradesPopupVisible &&
            !isBidPopupVisible &&
            !marketlogFilter.visible &&
            !isPopupVisible
        ) {
            actions.hideOnlineMarketLog();
        }
        if (isPopupVisible) {
            actions.hidePopup();
        }
        if (isLoginVisible) {
            actions.hideLogin();
        }
        if (isUserPopupVisible) {
            actions.hideUserPopup();
        }
        if (isForgotPopupVisible) {
            actions.hideForgotPopup();
        }
        if (context.visible) {
            actions.hideContext();
        }
        if (isSaveViewPopupVisible) {
            actions.hideSaveView();
        }
        if (inicesPopupVisible) {
            actions.hideIndicesPopup();
        }
        if (isBidPopupVisible) {
            actions.hideBidPopup();
        }
        if (isManageMarketPopupVisible) {
            actions.hideManageMarketPopup();
        }
        if (isManageProductPopupVisible) {
            actions.hideManageProductPopup();
        }

        if (isGridViewPopupVisible) {
            actions.hideGridViewPopup();
        }
        if (marketlogFilter.visible) {
            actions.hideMarketlogFilter();
        }
        if (isExpiredOrdersPopupVisible) {
            actions.hideExpiredOrdersPopup(); // TODO: IMPLEMENT THESE!
        }
        if (isCompletedTradesPopupVisible) {
            actions.hideCompletedTradesPopup(); // TODO: IMPLEMENT THESE!
        }
        if (isOrderPopupVisible) {
            actions.hideOrderPopup();
        }
        if (freightTypePopupVisible) {
            actions.hideFreightTypePopup();
        }
        if (isCustomNotificationPopupVisible) {
            actions.hideCustomNotificationPopup();
        }
    }

    render() {
        const { isGridViewPopupVisible, isGridViewSaving } = this.props.state.customViews;
        const {
            isPopupVisible,
            isUserPopupVisible,
            isForgotPopupVisible,
            isSetPasswordVisible,
            context,
            showProgress,
            popupProps,
            isSaveViewPopupVisible,
        } = this.props.state.app;
        const { isOrderPopupVisible } = this.props.state.orders;
        const { isExpiredOrdersPopupVisible } = this.props.state.orders; // TODO: Implement theese!
        const { isCompletedTradesPopupVisible } = this.props.state.orders; // TODO: Implement theese!
        const { inicesPopupVisible } = this.props.state.indices;
        const { isCustomNotificationPopupVisible } = this.props.state.notifications;
        const {
            isBidPopupVisible,
            isManageMarketPopupVisible,
            manageMarketPopupData,
            isManageProductPopupVisible,
            manageProductPopupData,
            isOnlineMarketLogVisible,
            isOnlineMarketLogGridVisible,
        } = this.props.state.markets;
        const { freightTypePopupVisible, freightTypePopupData } = this.props.state.freightTypes;
        const {
            showPopup,
            hidePopup,
            hideForgotPopup,
            hideManageMarketPopup,
            hideFreightTypePopup,
            hideManageProductPopup,
            manageMarket,
            manageProduct,
            manageFreightType,
            autoLogin,
            resetPassword,
            hideIndicesPopup,
            hideSaveView,
            saveCustomView,
            saveGridView,
            hideCustomNotificationPopup,
            sendCustomNotification,
        } = this.props.actions;

        const fetching = {
            user: this.props.state.user.fetching,
            companies: this.props.state.companies.fetching,
            freightTypes: this.props.state.freightTypes.fetching,
            markets: this.props.state.markets.fetching,
            orders: this.props.state.orders.fetching,
            systemlog: this.props.state.systemlogs.fetching,
            indices: this.props.state.indices.fetching,
        };

        const isLoading =
            showProgress ||
            fetching.user ||
            fetching.freightTypes ||
            fetching.companies ||
            fetching.markets ||
            fetching.orders ||
            fetching.systemlog ||
            fetching.indices;
        const isBluredOverlay =
            isPopupVisible ||
            isUserPopupVisible ||
            isOrderPopupVisible ||
            isManageMarketPopupVisible ||
            freightTypePopupVisible ||
            isManageProductPopupVisible ||
            inicesPopupVisible ||
            isSetPasswordVisible ||
            isForgotPopupVisible ||
            isGridViewPopupVisible ||
            isSaveViewPopupVisible;
        // let isBluredOverlay = isPopupVisible || isUserPopupVisible || isOrderPopupVisible || isExpiredOrdersPopupVisible || isCompletedTradesPopupVisible || isManageMarketPopupVisible || freightTypePopupVisible || isManageProductPopupVisible || inicesPopupVisible || isSetPasswordVisible || isForgotPopupVisible || isSaveViewPopupVisible;

        const isHome = !this.props.children;
        const { pathname } = this.props.location;
        const mainClass = pathname === '/reset' || pathname === '/forgot' ? 'responsive' : '';

        return (
            <div className={mainClass}>
                <Progress visible={isLoading} />
                {isOrderPopupVisible ? (
                    <SingleOrder
                        mode={this.props.state.orders.popupMode || ''}
                        isVisible={isOrderPopupVisible}
                        products={this.props.state.user.userInfo.products}
                        formData={this.props.state.orders.formData}
                        behalfUsers={this.props.state.orders.behalfUsers}
                        behalfUsersExtra={this.props.state.orders.behalfUsersExtra}
                        notificationUsers={this.props.state.orders.notificationUsers}
                        freightTypes={this.props.state.freightTypes.data}
                        currentUser={this.props.state.user.userInfo}
                        manageOrder={this.props.actions.manageOrder}
                        deleteOrder={this.props.actions.deleteOrder}
                        setOrderPopupMode={this.props.actions.setOrderPopupMode}
                        setShowTraded={this.props.actions.setShowTraded}
                        getOrder={this.props.actions.getOrder}
                        placeOrder={this.props.actions.placeOrder}
                        callDH={this.props.actions.callDH}
                        hidePopup={this.props.actions.hideOrderPopup}
                        getBehalfUsers={this.props.actions.getBehalfUsers}
                        getBehalfUsersExtra={this.props.actions.getBehalfUsersExtra}
                        getUsersWithNotification={this.props.actions.getUsersWithNotification}
                        getFreightTypes={this.props.actions.getFreightTypes}
                        freights={this.props.state.app.freights}
                        showPopup={this.props.actions.showPopup}
                    />
                ) : null}
                {isExpiredOrdersPopupVisible ? (
                    <ExpiredOrders
                        data={this.props.state.markets.marketLogData}
                        actions={this.props.actions}
                        isVisible={isExpiredOrdersPopupVisible}
                    />
                ) : null}
                {isCompletedTradesPopupVisible ? (
                    <CompletedTrades
                        data={this.props.state.markets.marketLogData}
                        actions={this.props.actions}
                        isVisible={isCompletedTradesPopupVisible}
                    />
                ) : null}
                {isBidPopupVisible ? (
                    <BidPopup
                        formData={this.props.state.markets.bidFormData}
                        behalfUsers={this.props.state.orders.behalfUsers}
                        hidePopup={this.props.actions.hideBidPopup}
                        currentUser={this.props.state.user}
                        updateBid={this.props.actions.updateBid}
                        showPopup={this.props.actions.showPopup}
                        getBehalfUsers={this.props.actions.getBehalfUsers}
                        visible={isBidPopupVisible}
                        freights={this.props.state.app.freights}
                    />
                ) : null}
                <Login />
                <UserPopup {...this.props} />
                <ForgotPopup
                    {...popupProps}
                    resetPassword={resetPassword}
                    visible={isForgotPopupVisible}
                    hidePopup={hideForgotPopup}
                />
                <SetPasswordPopup
                    token={this.props.location.query.token}
                    hidePopup={this.props.actions.hideSetPasswordPopup}
                    setNewPassword={this.props.actions.setNewPassword}
                    visible={isSetPasswordVisible}
                />
                <ManageMarketPopup
                    params={manageMarketPopupData}
                    hidePopup={hideManageMarketPopup}
                    manageMarket={manageMarket}
                    visible={isManageMarketPopupVisible}
                />
                <ManageProductPopup
                    data={manageProductPopupData}
                    hidePopup={hideManageProductPopup}
                    manageProduct={manageProduct}
                    autoLogin={autoLogin}
                    user={this.props.state.user}
                    visible={isManageProductPopupVisible}
                    showPopup={this.props.actions.showPopup}
                    freights={this.props.state.app.freights}
                />
                <FreightTypePopup
                    params={freightTypePopupData}
                    hidePopup={hideFreightTypePopup}
                    manageFreightType={manageFreightType}
                    autoLogin={autoLogin}
                    user={this.props.state.user}
                    visible={freightTypePopupVisible}
                    showPopup={this.props.actions.showPopup}
                />
                <CustomNotificationPopup
                    hidePopup={hideCustomNotificationPopup}
                    visible={isCustomNotificationPopupVisible}
                    products={this.props.state.user.userInfo.products}
                    markets={this.props.state.user.userInfo.markets}
                    sendCustomNotification={sendCustomNotification}
                    getUsersWithNotification={this.props.actions.getUsersWithNotification}
                    showPopup={showPopup}
                />
                <SaveViewPopup
                    hidePopup={hideSaveView}
                    saveView={saveCustomView}
                    views={this.props.state.user.userInfo.views}
                    userId={this.props.state.user.id}
                    marketLogArgs={this.props.state.markets.marketLogArgs}
                    visible={isSaveViewPopupVisible}
                />

                {isGridViewPopupVisible ? (
                    <ManageTabPopup
                        mode={this.props.state.customViews.mode}
                        data={this.props.state.customViews.selectedView}
                        hidePopup={this.props.actions.hideGridViewPopup}
                        saveView={saveGridView}
                        user={this.props.state.user}
                        isViewSaving={isGridViewSaving}
                        views={this.props.state.user.userInfo.views}
                    />
                ) : null}
                {inicesPopupVisible ? (
                    <IndexPopup
                        markets={this.props.state.markets.data}
                        indices={this.props.state.indices}
                        products={this.props.state.user.userInfo.products}
                        refresh={this.props.actions.getAllIndices}
                        getSchedule={this.props.actions.getFullSchedule}
                        setMarketId={this.props.actions.setMarketId}
                        setFrequencyType={this.props.actions.setFrequencyType}
                        setSelectedDate={this.props.actions.setSelectedDate}
                        showProgress={this.props.actions.showProgress}
                        hideProgress={this.props.actions.hideProgress}
                        hidePopup={hideIndicesPopup}
                        visible={inicesPopupVisible}
                    />
                ) : null}
                <Popup {...popupProps} visible={isPopupVisible} showPopup={showPopup} hidePopup={hidePopup} />
                <div className={`body-container ${isBluredOverlay && 'blur'}`}>
                    <div className="content-container">
                        <Header userState={this.props.state.user} appActions={this.props.actions} />

                        <div className={`content-container-body ${isHome ? 'home-container' : ''}`}>
                            {isHome ? <Homescreen {...this.props} /> : this.props.children}
                        </div>
                        <Footer />
                    </div>
                </div>
                {context.visible ? (
                    <ContextMenu
                        showOrder={this.props.actions.showOrderPopup}
                        duplicateOrder={this.props.actions.duplicateOrderPopup}
                        getOrder={this.props.actions.getOrder}
                        deleteOrder={this.props.actions.deleteOrder}
                        setShowTraded={this.props.actions.setShowTraded}
                        close={this.props.actions.hideContext}
                        user={this.props.state.user}
                        visible={context.visible}
                        params={context.params}
                        freightTypes={this.props.state.freightTypes.data}
                        behalfUsers={this.props.state.orders.behalfUsers}
                        screenUrl={this.props.state.routing.locationBeforeTransitions.pathname}
                        isOnlineMarketLogVisible={isOnlineMarketLogVisible}
                        isOnlineMarketLogGridVisible={isOnlineMarketLogGridVisible}
                        showSaveView={this.props.actions.showSaveView}
                        getBehalfUsers={this.props.actions.getBehalfUsers}
                        marketLogArgs={this.props.state.markets.marketLogArgs}
                        freights={this.props.state.app.freights}
                        x={context.x}
                        y={context.y}
                    />
                ) : (
                    ''
                )}
                {this.props.state.user.isImpersonating ? (
                    <ImpersonatingBanner
                        user={this.props.state.user}
                        stopImpersonating={this.props.actions.stopImpersonating}
                    />
                ) : null}
            </div>
        );
    }
}

export default connect(
    state => ({
        state,
    }),
    dispatch => ({
        actions: bindActionCreators(
            {
                ...appActions,
                ...userActions,
                ...ordersActions,
                ...marketsActions,
                ...customViewsActions,
                ...companiesActions,
                ...indicesActions,
                ...freightTypesActions,
                ...socketActions,
                ...notificationsActions,
            },
            dispatch,
        ),
    }),
)(App);



// WEBPACK FOOTER //
// ./source/screens/App.js